// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const piloswine: PokeData = {
  "id": 221,
  "name": "piloswine",
  "height": 11,
  "weight": 558,
  "base_experience": 158,
  "types": [
    PokeType.ICE,
    PokeType.GROUND
  ],
  "api_moves": [
    "horn-attack",
    "fury-attack",
    "tackle",
    "take-down",
    "thrash",
    "double-edge",
    "mist",
    "blizzard",
    "peck",
    "earthquake",
    "amnesia",
    "flail",
    "powder-snow",
    "mud-slap",
    "icy-wind",
    "endure",
    "ancient-power",
    "mud-sport",
    "odor-sleuth",
    "ice-shard",
    "ice-fang",
    "mud-bomb",
    "bulldoze",
    "icicle-crash",
    "high-horsepower"
  ],
  "moves": [
    "tackle",
    "blizzard",
    "peck",
    "earthquake",
    "mud-slap",
    "ancient-power",
    "ice-shard",
    "ice-fang",
    "mud-bomb",
    "aurora-veil",
    "icicle-dagger",
    "mud-shot",
    "bone-throw"
  ],
  "evolution_chain": {
    "id": 112,
    "item": null,
    "species": [
      {
        "name": "swinub",
        "order": 251,
        "types": [
          PokeType.ICE,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "piloswine",
        "order": 252,
        "types": [
          PokeType.ICE,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 220,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 33,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "mamoswine",
        "order": 253,
        "types": [
          PokeType.ICE,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 221,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "ancient-power"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 85,
    "speed": 50,
    "ability_power": 100
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
